<div class="auth-items" [style]="wrap && !isAuth ? 'display: flex; flex-direction: column' : ''" [ngClass]="{ logged: isAuth }">
  <ng-container *ngIf="!isAuth">
    <a mat-raised-button color="tech-button-bg-secondary" routerLink="/auth/sign-in" (click)="buttonClick.emit()" routerLinkActive="active">{{ 'WM_TECH.HEADER.SIGNIN' | translate }}</a>
    <a mat-raised-button color="tech-button-bg-primary" routerLink="/auth/sign-up" (click)="buttonClick.emit()" routerLinkActive="active">{{ 'WM_TECH.HEADER.SIGNUP' | translate }}</a>
  </ng-container>

  <ng-container *ngIf="isAuth">
    <ng-container *ngIf="app === 'wm-tech'; else mmsAndPoolTemplate">
      <a routerLink="/profile"><img src="assets/images/header/profile.svg" (click)="buttonClick.emit()" alt="Profile" [style]="isDarkMode ? 'filter: invert(1)' : 'filter: none'" /></a>
    </ng-container>
    <a (click)="logOut()" class="logout"><img src="assets/images/header/logout.svg" (click)="buttonClick.emit()" alt="Logout" [style]="isDarkMode ? 'filter: invert(1)' : 'filter: none'" /></a>
  </ng-container>
</div>

<ng-template #mmsAndPoolTemplate>
  <a href="{{ env.techDomain }}/profile"><img src="assets/images/header/profile.svg" (click)="buttonClick.emit()" alt="Profile" [style]="isDarkMode ? 'filter: invert(1)' : 'filter: none'" /></a>
</ng-template>
